import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { useUpdateApplication} from '../../hooks/queries';
import BaseCard from './BaseCard';
import { AMPLITUDE_EVENTS } from '../../constants';
import { useMobileAppLaunchStore } from '../../Store/useMobileAppLaunchStore';
import { detectDevice } from '../../util/mobileAppUtils';
import { detectBrowser } from '../../util/DriveUtils';
import {setDocumentTitle} from '../../util/TitleManager';
import {DEVICE} from '../../constants';

interface Props {
  id: string;
  isEnabled: boolean;
  isFavorite?: boolean;
  description: string;
  name: string;
  iconColor: string;
  iconText: string;
  url: string;
  onCdkuOpen: Function
  cdkuUrl: string;
  playStoreUrl: string;
  appStoreUrl: string;
  isRestricted:boolean;
  restrictedTooltipMsg:string;
  openInNewTab?:boolean;
}

export default function MobileApplicationCard({
  id,
  isFavorite,
  isEnabled,
  description,
  name,
  iconColor,
  iconText,
  onCdkuOpen,
  cdkuUrl = '',
  url,
  playStoreUrl= '',
  appStoreUrl='',
  isRestricted,
  restrictedTooltipMsg,
  openInNewTab
}: Props) {
  
  const { mutate } = useUpdateApplication();

  const { trackEvent } = useAnalytics();

  const setShowDialog = useMobileAppLaunchStore((state:any) => state.setShowDialog);
  const setAppName = useMobileAppLaunchStore((state:any) => state.setAppName);
  const setAppIcon = useMobileAppLaunchStore((state:any) => state.setAppIcon);
  const setAppIconColor = useMobileAppLaunchStore((state:any) => state.setAppIconColor);
  const setAppDescription = useMobileAppLaunchStore((state:any) => state.setAppDescription);
  const setAppDownloadUrl = useMobileAppLaunchStore((state:any) => state.setAppDownloadUrl);
  const device = detectDevice();
  const browser = detectBrowser();
  let browserCode = '';

  switch (browser) {
    case "Google Chrome":
        browserCode = "chrome";
      break;
    case "Mozilla Firefox":
        browserCode = "firefox";
      break;
    case "Apple Safari":
        browserCode = "safari";
      break;
    case "Microsoft Edge":
        browserCode = "edge";
      break;
    case "Internet Explorer":
        browserCode = "internetexplorer";
      break;
    case "Opera":
        browserCode = "opera";
      break;
    default:
        browserCode = "";
  }

  const handleOpenMobileApp = async () => {
    setDocumentTitle(name, url);
    trackEvent(AMPLITUDE_EVENTS.OPEN_APPLICATION, {
      Application: name,
    });
    if (browserCode && browserCode !== '') {
      url = url + '&browser=' + browserCode
    }

    const timeOut = browserCode === 'safari' ? 4000 : 2000;

    const checkDeepLink = setTimeout(() => {
      if (!appOpened) {
        setShowDialog(true);
        setAppName(name);
        setAppIcon(iconText);
        setAppIconColor(iconColor);
        setAppDescription(description);
        device === DEVICE.IOS ? setAppDownloadUrl(appStoreUrl) : setAppDownloadUrl(playStoreUrl);
      }
    }, timeOut);

    const onVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        clearTimeout(checkDeepLink);
        setShowDialog(false);
      }
    };

    window.addEventListener('visibilitychange', onVisibilityChange);

    let appOpened = false;
    window.location.href = url;

    setTimeout(() => {
      window.removeEventListener('visibilitychange', onVisibilityChange);
    }, 6000);
  };

  const onFavoriteClick = () => {
    mutate({ id, isFavorite: Boolean(!isFavorite) });
    trackFavoriteChange(!isFavorite);
  };

  const trackFavoriteChange = (isFavorite: boolean) => {
    isFavorite &&
      trackEvent(AMPLITUDE_EVENTS.OPEN_APPLICATION, {
        'Favorite Application': name,
      });
  };

  return (
    <>
      <BaseCard
        onOpenClick={handleOpenMobileApp}
        name={name}
        iconColor={iconColor}
        description={description}
        iconText={iconText}
        isEnabled={true}
        isFavorite={isFavorite}
        onFavoriteClick={onFavoriteClick}
        isIconRequired={true}
        onCdkuOpen={onCdkuOpen}
        cdkuUrl={cdkuUrl}
        isMobileApp={isEnabled}
        isRestricted={isRestricted}
        restrictedTooltipMsg={restrictedTooltipMsg}
        url={url}
        openInNewTab={openInNewTab}
        id={id}
        setDefaultApp={function (): void{}}
      />
    </>
  );
}
